<template lang="pug">
.pulldown-select.line-height-none
  select-base.pulldown-select__select(@input='updateValue', :disabled='disabled')
    option-base.pulldown-select__select__option(
      v-for='(option, index) in selectOptions',
      :value='option.value',
      :key='index',
      :selected='option.value === value'
    ) {{ option.label }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import SelectBase from '@/components/atoms/SelectBase.vue'
import OptionBase from '@/components/atoms/OptionBase.vue'
import { InputItem } from '@/models/inputItem'

/**
 * プルダウン
 */
@Component({
  components: {
    SelectBase,
    OptionBase,
  },
})
export default class PulldownSelect extends Vue {
  // セレクトオプション
  @Prop()
  selectOptions!: InputItem[]

  // 選択値
  @Prop({ default: '' })
  value!: string

  @Prop({ default: false })
  disabled?: boolean

  private updateValue(value: string): void {
    this.$emit('input', value)
  }
}
</script>

<style lang="stylus" scoped>
.pulldown-select
  min-width 170px
  position relative
  &__select
    width 100%
    appearance none
    outline none
    padding 9px 36px 9px 20px
    border 1px solid var(--color-input-manager-pulldown__border)
    border-radius 60px
    background-color var(--color-input-manager-pulldown__background)

    &:hover
      border-color transparent
      background-color var(--color-input-manager-pulldown__hover)

    &:disabled
      background-color var(--color-input-manager-pulldown__background-disabled)
      color unset
      opacity unset
      cursor default

  &::before
    position absolute
    top 35%
    right 20px
    width 8px
    height 8px
    padding 0
    content ''
    border-right 2px solid var(--color-input-manager-pulldown__border)
    border-bottom 2px solid var(--color-input-manager-pulldown__border)
    transform rotate(45deg)
    pointer-events none
</style>
